import { useCompanyFeatures } from 'app/domains/companies';
import { useGetCurrentUser } from 'shared/domains/documents';
import { PleditorError } from '../../components/PleditorError';
import { PleditorLoader } from '../../components/PleditorLoader';
import { useGetUserIdAccess } from '../../hooks/useGetUsersAccess';
import { RTCPleditor } from '../RTCPleditor';
import { useGetDocumentData } from '../hooks';
import { APP_COMPOSED_PLUGINS } from '../plugins';
export function AppComposedRTCPleditor() {
    const currentUser = useGetCurrentUser();
    const { usersExternal, usersWithoutAccess, usersWithAccess } = useGetUserIdAccess();
    const { documentId, documentBody, loading, error } = useGetDocumentData();
    const { isFeatureAvailable } = useCompanyFeatures();
    const isDocumentAssistantAvailable = isFeatureAvailable('document-assistant:basic');
    if (loading) {
        return <PleditorLoader />;
    }
    if (error) {
        return <PleditorError />;
    }
    const toolbarItems = [
        '<->',
        'blockComment',
        // '|',
        // 'customCommentsArchive',
        '|',
        'toggleComments',
        'toggleComposedHighlights',
    ];
    const balloonToolbarItems = isDocumentAssistantAvailable
        ? ['blockCommentCompact', '|', 'inlineAssistantShortcut']
        : ['blockCommentCompact'];
    return (<RTCPleditor documentType="composed" documentId={documentId} documentBody={documentBody} toolbarItems={toolbarItems} balloonToolbarItems={balloonToolbarItems} currentUser={currentUser} usersExternal={usersExternal} usersWithAccess={usersWithAccess} usersWithoutAccess={usersWithoutAccess} plugins={APP_COMPOSED_PLUGINS}/>);
}
